import { Card, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../MainPages.css';

export default function Pessoal() {
    return (
        <Row>
            <Col xs="12">
                <p><small>Você está em Gestão de Pessoas</small></p>
                <h1>Gestão de Pessoas</h1>
                <h3>Consulte:</h3>
            </Col>
            <Col xs="12">
                <Link to="/pessoal/listagem-servidores" title="Listagem de Pessoal">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Listagem de Pessoal
                        </Card.Body>
                    </Card>
                </Link>
            </Col>

            <Col xs="12">
                <Link to="https://legis.alepe.pe.gov.br/texto.aspx?id=32&tipo=" target="_blank" title="Planos de Cargos">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Planos de Cargos
                        </Card.Body>
                    </Card>
                </Link>
            </Col>

            <Col xs="12">
                <Link to="/pessoal/servidores-efetivos" title="Servidores Efetivos">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Servidores Efetivos
                        </Card.Body>
                    </Card>
                </Link>
            </Col>

            <Col xs="12">
                <Link to="/pessoal/servidores-comissionados" title="Servidores Comissionados">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Servidores Comissionados
                        </Card.Body>
                    </Card>
                </Link>
            </Col>

            <Col xs="12">
                <Link to="/pessoal/servidores-lotacao" title="Por Lotação">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Por Lotação
                        </Card.Body>
                    </Card>
                </Link>
            </Col>

            <Col xs="12">
                <Link to="/pessoal/servidores-cedidos" title="Servidores Cedidos">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Servidores Cedidos
                        </Card.Body>
                    </Card>
                </Link>
            </Col>

            <Col xs="12">
                <Link to="/pessoal/servidores-outros-orgaos" title="Servidores à Disposição">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Servidores à Disposição
                        </Card.Body>
                    </Card>
                </Link>
            </Col>

            <Col xs="12">
                <Link to="/pessoal/servidores-remuneracao" title="Tabelas de Remuneração">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Tabelas de Remuneração
                        </Card.Body>
                    </Card>
                </Link>
            </Col>

            <Col xs="12">
                <Link to="https://www.alepe.pe.gov.br/atos-portarias" title="Atos e Portarias">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Atos e Portarias
                        </Card.Body>
                    </Card>
                </Link>
            </Col>

            <Col xs="12">
                <Link to="/pessoal/concurso-publico" title="Concurso Público">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Concurso Público
                        </Card.Body>
                    </Card>
                </Link>
            </Col>
        </Row>
    );
}
